import mark from './qed-mark.svg';

const LogoIcon = () => <img src={mark} alt="QED" style={{ height: 28 }} />;

export default LogoIcon;
